module.exports = __webpack_public_path__ + "img/14.6a8b6e88.png";